import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Author } from "../../basic/author.js";

import { HeroImage } from "../../atoms/hero-image";

import { getStoryCards } from "../../sso-components/sso-utils.js";
import { StoryHeadline } from "../../atoms/story-headline/index.js";
import { StorySection } from "../../atoms/story-section/index.js";
import { ImageFallback } from "../../basic/image-fallback";

import "./snapshot.m.css";

function Snapshot(props) {
  const haveFocusPoint = !!get(props, ["story", "hero-image-metadata", "focus-point"]);

  const publishedTime = props.story["last-published-at"]
    ? props.story["last-published-at"]
    : props.story["first-published-at"];
  const authorsArray = get(props.story, ["authors"])
    ? get(props.story, ["authors"])
    : [
        {
          name: props.story["author-name"],
          id: props.story["author-id"]
        }
      ];

  const cdnImage = get(props, ["config", "cdn-image"], "");
  const storyCards = get(props, ["story", "cards"], []);

  function getImageTemplate(props) {
    const image = get(props.story, ["hero-image-s3-key"]);
    if (image) {
      return (
        <figure styleName={`image-wrapper ${!haveFocusPoint ? "full-height" : ""}`}>
          <HeroImage story={props.story} desktopAspectRatio={[16, 9]} mobileAspectRatio={(16, 9)} />
        </figure>
      );
    } else {
      return (
        <div>
          <ImageFallback />
        </div>
      );
    }
  }

  function getAuthor(props) {
    return <Author config={props.config} authors={authorsArray} isLink showDateOnly date={publishedTime} />;
  }

  return (
    <div data-testid="text-story-grid" styleName="snapshot-wrapper">
      {/* hero image */}
      <div styleName="item image" data-testid="text-story-image">
        {getImageTemplate(props)}
      </div>

      {/* Section-name */}
      <div styleName="item section-name">
        <StorySection story={props.story} config={props.config} />
      </div>

      {/* Headline */}
      <div styleName="item">
        <StoryHeadline headline={props.story.headline} />
      </div>

      {/* Author */}
      <div styleName="item" data-testid="text-story-author">
        {getAuthor(props)}
      </div>

      {/* Story-cards */}
      <div styleName="item">
        {getStoryCards(storyCards, props.config, props.story, cdnImage, props.getStoryCardTemplate, props.firstStory)}
      </div>
    </div>
  );
}
Snapshot.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  getStoryCardTemplate: PropTypes.func,
  firstStory: PropTypes.bool
};

export { Snapshot };
